<template>
  <div v-wechat-title="title" style="height:100%">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
    name: `Transfer`,
    props: {

    },
    data() {
        return {
            title: `患者转运`
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Transfer/Index.vue